export const DEFAULT_BASE_URL = 'https://api-beta-restockify.shopgram.app';
export const CANNY_BOARD_TOKEN = 'f59c68b9-8292-3688-794a-d79a4d4afa72';
export const CANNY_APP_ID = '60740e55e7ff7c60ea60a308';

export const PATHS = {
  HOME: '/',
  HELP: '/help',
  LOGIN: '/support/login/',

  PRICING: '/plans',
  AUCTION: '/auction',
  CAMPAIGNS: '/campaigns',
  CREATE_CAMPAIGN: '/campaigns/create-campaign',
  EDIT_CAMPAIGN: '/campaigns/edit-campaign',
  SETTING: '/setting',
  FEATURE_REQUEST: '/feature-request',
  WIDGETS: '/widgets',
  COUNTDOWN_SETTINGS: '/countdown-settings',
  HELP_SUB_PAGES: {
    CREATE_CAMPAIGN: 'create-campaign',
    IMPORTANT_TIPS: 'important-tips',
    FAQ: 'faq',
    CONTACT_US: 'contact-us',
    feature_request: 'feature-request',
  },
  SETTING_SUB_PAGES: {
    custom_notifications: 'customer-notification',
    MANAGE_DISCOUNTS: 'manage-discounts',
    Label_DISCOUNTS: 'lable-discount',
  },
  ANALYTICS: '/analytics',
  SAFE_UNINSTALL: '/safe-uninstall',
  WHOLESALE_TOOLS: '/wholesale-tools',
  CAMPAIGN_OVERLAPS: '/campaigns/overlaps',
  // Sidekick edit-discount intent: /campaigns/by-discount/<shopify discount id>
  CAMPAIGN_BY_DISCOUNT: '/campaigns/by-discount',
  SIMULATOR: '/simulator',
  OPPORTUNITIES: '/opportunities',
  CAMPAIGN_CALENDAR: '/campaigns/calendar',
  CHECK_PRODUCT: '/campaigns/check-product',
};

export const PRICING_PERIODS = {
  MONTH: 0,
  YEAR: 1,
};
export const TABLE_ROWS_PER_PAGE = 10;

export const primaryDiscountRule = {
  discountType: 0,
  discountValue: '',
  minValue: '',
  maxValue: '',
  minType: 1,
};

export const campaignTypes = {
  General: true,
  Volume: false,
  Order: 0,
  BOGO: 3,
  BOGOPurchase: 4,
  Countdown: 5,
  Shipping: 6,
  Bundle: 7,
  CrossSell: 8,
  Wholesale: 9,
  Dropshipper: 10,
  FreeGift: 11,
  Upsell: 12,
};

export const campaignFocusedTypes = {
  countdown: 'countdown',
};

// Maps a campaign type (campaignTypes value) to the plan feature key that gates
// it. A type is "locked" for a shop when this key is NOT in the shop's
// currentPlanFeatureKeys. Single source of truth shared by the type-selection
// screen and the campaign builder's "will be blocked" detection.
export const campaignTypeFeatureKey = {
  [campaignTypes.General]: 'flat-product-discount',
  [campaignTypes.Volume]: 'tiered-quantity-discount',
  [campaignTypes.Order]: 'tiered-spend-discount',
  [campaignTypes.BOGO]: 'buy-x-get-y',
  [campaignTypes.BOGOPurchase]: 'buy-x-get-y',
  [campaignTypes.Shipping]: 'free-shipping',
  [campaignTypes.Wholesale]: 'wholesale-b2b-pricing',
  [campaignTypes.Dropshipper]: 'dropshipper-pricing',
  // Simple bundles are on Premium, Prime and Ultimate (Plans v6, owner decision reversing B25-1):
  // gated by `bundle-simple`, which the v6 migration links to the new Premium row and to every
  // row that had `bundle-fixed-product`. Backend findCampaignTypeKey uses the same key.
  [campaignTypes.Bundle]: 'bundle-simple',
  [campaignTypes.CrossSell]: 'cross-sell-rule-based',
  [campaignTypes.FreeGift]: 'free-gift',
  [campaignTypes.Upsell]: 'upsell-upgrade-offer',
};

// Ultimate-only sub-features of the Bundle / Cross-sell / Gift types. The type
// itself is gated by campaignTypeFeatureKey; these gate individual controls
// inside the builders (rule slots, optional slots, set ladders, smart offers,
// multi-tier gifts, ...).
export const ULTIMATE_FEATURE_KEYS = {
  ADVANCED_BUNDLES: 'advanced-bundles',
  AI_CROSS_SELL: 'ai-cross-sell',
  ADVANCED_GIFTS: 'advanced-gifts',
  // Upsell `offer.source: 'smart'` (auto-materialized upgrade ladders) — upsell plan D11.
  SMART_LADDERS: 'smart-upsell-ladders',
};

// Prime-level sub-features of the Bundle builder (Plans v6). The type itself is Prime+.
// Collection / tag / vendor / type slots and repeat-per-set (with max sets) need these.
export const PRIME_FEATURE_KEYS = {
  BUNDLE_COLLECTION_SLOTS: 'bundle-collection-slots',
  BUNDLE_SET_OPTIONS: 'bundle-set-options',
};

export const serverCampaignTypes = {
  General: 'general',
  Volume: 'volume',
  Order: 'order',
  BOGO: 'buy_one_get_one',
  Shipping: 'shipping',
  Bundle: 'bundles',
  CrossSell: 'cross_sell',
  Wholesale: 'wholesale',
  Dropshipper: 'dropshipper',
  FreeGift: 'free_gift',
  Upsell: 'upsell',
};

export const bogoDiscountType = {
  minimumQuantity: 0,
  minimumPurchaseAmount: 1,
};

export const campaignMinType = {
  minimumQuantity: 0,
  minimumPurchaseAmount: 1,
  noMin:2
};

export const discountTypes = {
  percentage: 0,
  fixPrice: 1,
  newPrice: 2,
  freeShipping: 3,
};

export const newPriceDiscountTypes = {
  percentage: 0,
  fixPrice: 1,
  newPrice: 2,
};

export const newPriceChangeModeType = {
  increase: 0,
  decrease: 1,
};

// Dropshipper Pricing — what the discount/repricing is computed against.
//   sellingPrice → plain discount off the selling price (manual price floor)
//   profitMargin → discount comes out of the margin (cost + min-profit floor)
//   productCost  → selling price is rebuilt from cost (cost + markup)
export const pricingBaseTypes = {
  sellingPrice: 0,
  profitMargin: 1,
  productCost: 2,
};

export const campaignCustomerGetType = {
  free: 1,
  percentage: 2,
  fixPrice: 3,
  freeShipping: 4,
};

export const campaignCustomerGetProductType = {
  sameProduct: 'sameProduct',
  selectProduct: 'selectProduct',
};

export const campaignWidgetStyle = {
  none: 'none',
  modal: 'modal',
  toast: 'toast',
};
